import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TheadColumn, TheadGroup} from "../thead/thead-column";
import {TableSorter} from "../thead/table-sorter";

@Component({
    selector: '[app-thead-grouped]',
    templateUrl: './app-thead-grouped.component.html',
    styleUrls: ['./app-thead-grouped.component.css']
})
export class AppTheadGroupedComponent implements OnInit {
    @Input() theadGroups: TheadGroup[] = [];
    @Input() tableSorter: TableSorter = new TableSorter();
    @Output() changeOrder = new EventEmitter<string>();

    constructor() {
    }

    ngOnInit(): void {
        for (let i = 0; i < this.theadGroups.length; i++) {
            for (let col of this.theadGroups[i].columns) {
                this.tableSorter.add(col.columnSortingName);
            }
        }
    }

    changeOrderEmit() {
        this.changeOrder.emit('changeOrder');
    }

    clickEvent(col: TheadColumn) {
        this.tableSorter.toggle(col.columnSortingName);
        this.changeOrderEmit();
    }

}

